import React from 'react';
import { Box, Stack, Input, Textarea, Button, Heading, Text, Avatar, Flex, Card, CardHeader, CardBody, Icon } from '@chakra-ui/react';
import { FaUser } from 'react-icons/fa';
import axios from 'axios';
import Swal from 'sweetalert2';

function MyProfile({ initialFullName, initialEmail, initialRole }) {
  const [isEditable, setIsEditable] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState('');
  const [profileData, setProfileData] = React.useState({
    avatarSrc: '',
    FullName: initialFullName,
    userName: '',
    licenseId: '',
    password: '',
    email: initialEmail,
    contact_no: '',
    bio: '',
    address: {
      street: '',
      city: '',
      state: '',
      country: '',
      pinCode: ''
    },
    specialties: '',
    services: '',
    organization_type: '',
    accreditations: '',
    role: initialRole,
    country_code: '',
    individual_identity: '',
    agencyDetails: {
      licenseId: '',
      certification: '',
      certificationExpiry: '',
      issuingAuthority: ''
    },
    organizational_specialization: ''
  });

  React.useEffect(() => {
    const fetchProfileData = async () => {
      const ticketToken = sessionStorage.getItem('ticketToken');
      if (!ticketToken) {
        console.error('No ticket token found in sessionStorage');
        return;
      }
      // console.log('Ticket Token:', ticketToken);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/provider/get-provider-details`,
          {
            headers: {
              Authorization: `Bearer ${ticketToken}`
            }
          }
        );
        console.log('Response data:', response.data); // Log the response data

        // Update to match the response structure
        setProfileData({
          FullName: response.data.data.FullName || '',
          email: response.data.data.email || '',
          role: response.data.data.role || '',
          country_code: response.data.data.country_code || '',
          address: {
            street: response.data.data.address?.street || '',
            city: response.data.data.address?.city || '',
            state: response.data.data.address?.state || '',
            country: response.data.data.address?.country || '',
            pinCode: response.data.data.address?.pinCode || ''
          },
          individual_identity: response.data.data.individual_identity || '',
          agencyDetails: {
            licenseId: response.data.data.agencyDetails?.licenseId || '',
            certification: response.data.data.agencyDetails?.certification || '',
            certificationExpiry: response.data.data.agencyDetails?.certificationExpiry || '',
            issuingAuthority: response.data.data.agencyDetails?.issuingAuthority || ''
          },
          organization_type: response.data.data.organization_type || '',
          organizational_specialization: response.data.data.organizational_specialization || '',
          bio: response.data.data.bio || '',
          contact_no: response.data.data.contact_no || ''
        });
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    };

    fetchProfileData();
  }, []);

  const submitProviderDetails = async (event) => {
    event.preventDefault(); // Prevent the default form submission behavior

    const formData = new FormData(event.target);
    const tempData = {};

    // Convert form data to a plain object
    formData.forEach((value, key) => {
      if (key.startsWith('address.')) {
        const addressKey = key.split('.')[1];
        if (!tempData.address) tempData.address = {};
        tempData.address[addressKey] = value;
      } else if (key.startsWith('agencyDetails.')) {
        const agencyKey = key.split('.')[1];
        if (!tempData.agencyDetails) tempData.agencyDetails = {};
        tempData.agencyDetails[agencyKey] = value;
      } else {
        tempData[key] = value;
      }
    });

    const ticketToken = sessionStorage.getItem('ticketToken');
    if (!ticketToken) {
      console.error('No ticket token found in sessionStorage');
      return;
    }
    // console.log('Ticket Token:', ticketToken);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/provider/update-provider-details`,
        tempData,
        {
          headers: {
            Authorization: `Bearer ${ticketToken}`
          }
        }
      );
      console.log('Response data:', response.data); // Log the response data
      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Profile Updated!',
          text: 'Your profile has been updated successfully.',
          showConfirmButton: false,
          timer: 2000, // Automatically close after 2 seconds
          width: '300px',
          padding: '1em',
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          }
        });

       // console.log('works');
        //alert('Profile updated successfully');
        setIsEditable(false);
      }else{
        //alert('Profile update failed');
        Swal.fire({
          icon: 'error',
          title: 'Update Failed',
          text: 'Profile update failed. Please try again.',
          footer: '<a href="#">Why do I have this issue?</a>',
          width: '300px',
          padding: '1em',
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          }
        });
      }
      

      // Optionally update the profile data after submission
      setProfileData({
        ...profileData, // Keep existing data
        // You can update any specific fields if needed
      }
      

    );
    } catch (error) {
      console.error('Error submitting profile data:', error); // Updated error message
      //alert('Error submitting profile data:', error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'There was an error submitting your profile data. Please try again later.',
        footer: `<a href="#">Why do I have this issue?</a>`, // Optional: Add a footer link for more info
        width: '300px', // Adjust the width to make it smaller
        padding: '1em', // Adjust padding for a more compact look
        showClass: {
          popup: 'animate__animated animate__fadeInDown' // Optional: Add animation for entry
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp' // Optional: Add animation for exit
        }
      });
    }
  };

  const handleEditClick = () => {
    setIsEditable(true);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setSelectedImage(imageUrl);
      // Implement logic to upload the image to the server here
    }
  };

  return (
    <Box flex="1" p={4} overflowY="auto" width="100%" maxW="100%" mx="auto" borderRadius="md" boxShadow="lg">
      <form onSubmit={submitProviderDetails}>
        <Flex justifyContent="space-between" alignItems="center" mb={4}>
          <Heading fontSize={["lg", "xl"]} textAlign="left">Profile</Heading>
          <Box>
            <Button colorScheme="teal" size="sm" mr={2} onClick={handleEditClick}>Edit</Button>
            <Button colorScheme="blue" size="sm" type="submit" disabled={!isEditable}>Submit</Button>
          </Box>
        </Flex>
        <Text mb={4} fontSize={["xs", "sm"]} textAlign="left">
          This is how others will see you on the site.
        </Text>

        {(!profileData.role || profileData.role.trim() === '') ? (
          <Stack spacing={3}>
            <Box>
              <Text fontWeight="bold" textAlign="left">User Name</Text>
              <Input name="userName" defaultValue={profileData.userName} isReadOnly={!isEditable} />
            </Box>
            <Box>
              <Text fontWeight="bold" textAlign="left">Email</Text>
              <Input name="email" placeholder="Email" defaultValue={profileData.email} isReadOnly={!isEditable} />
            </Box>
          </Stack>
        ) : (
          <>
            <Flex alignItems="center" mb={4}>
              <Avatar 
                size="2xl" 
                src={selectedImage || profileData.avatarSrc} 
                icon={<Icon as={FaUser} />} 
                mr={4} 
              />
              {isEditable && (
                <Box>
                  <Input type="file" name="avatar" accept="image/*" onChange={handleImageChange} width="100px" 
                  
                  size="sm" // Reduce the size of the input
                  p={1} // Reduce padding
                  borderRadius="md"/>
                </Box>
              )}
            </Flex>

            <Card mb={6} boxShadow="2xl" borderRadius="md">
              <CardHeader>
                <Heading fontSize="md" textAlign="left">
                  {profileData.role === 'individual_provider' ? 'Personal Information' : 'Organizational Information'}
                </Heading>
              </CardHeader>
              <CardBody>
                <Stack spacing={3}>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">
                      {profileData.role === 'individual_provider' ? 'Name' : 'Organization Name'}
                    </Text>
                    <Input name="FullName" defaultValue={profileData.FullName} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">
                      {profileData.role === 'individual_provider' ? 'Identity' : 'License ID'}
                    </Text>
                    <Input name="individual_identity" defaultValue={profileData.individual_identity} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">User Name</Text>
                    <Input name="userName" defaultValue={profileData.userName} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Password</Text>
                    <Input name="password" placeholder="Password" type="password" defaultValue={profileData.password} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Email</Text>
                    <Input name="email" placeholder="Email" defaultValue={profileData.email} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Contact Number</Text>
                    <Input name="contact_no" defaultValue={profileData.contact_no} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Role</Text>
                    <Input name="role" defaultValue={profileData.role} isReadOnly={true} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Country Code</Text>
                    <Input name="country_code" defaultValue={profileData.country_code} isReadOnly={!isEditable} />
                  </Box>
                </Stack>
              </CardBody>
            </Card>

            <Card mb={6} boxShadow="2xl" borderRadius="md">
              <CardHeader>
                <Heading fontSize="md" textAlign="left">Address Information</Heading>
              </CardHeader>
              <CardBody>
                <Stack spacing={3}>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Street</Text>
                    <Input name="address.street" defaultValue={profileData.address.street} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">City</Text>
                    <Input name="address.city" defaultValue={profileData.address.city} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">State</Text>
                    <Input name="address.state" defaultValue={profileData.address.state} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Country</Text>
                    <Input name="address.country" defaultValue={profileData.address.country} isReadOnly={!isEditable} />
                  </Box>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Pin Code</Text>
                    <Input name="address.pinCode" defaultValue={profileData.address.pinCode} isReadOnly={!isEditable} />
                  </Box>
                </Stack>
              </CardBody>
            </Card>

            <Card mb={6} boxShadow="2xl" borderRadius="md">
              <CardHeader>
                <Heading fontSize="md" textAlign="left">Additional Information</Heading>
              </CardHeader>
              <CardBody>
                <Stack spacing={3}>
                  <Box>
                    <Text fontWeight="bold" textAlign="left">Bio</Text>
                    <Textarea name="bio" placeholder="Bio" defaultValue={profileData.bio} isReadOnly={!isEditable} />
                  </Box>
                </Stack>
              </CardBody>
            </Card>

            {profileData.role !== 'individual_provider' && (
              <>
                <Card mb={6} boxShadow="2xl" borderRadius="md">
                  <CardHeader>
                    <Heading fontSize="md" textAlign="left">Agency Details</Heading>
                  </CardHeader>
                  <CardBody>
                    <Stack spacing={3}>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Agency License ID</Text>
                        <Input name="agencyDetails.licenseId" defaultValue={profileData.agencyDetails.licenseId} isReadOnly={!isEditable} />
                      </Box>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Certification</Text>
                        <Input name="agencyDetails.certification" defaultValue={profileData.agencyDetails.certification} isReadOnly={!isEditable} />
                      </Box>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Certification Expiry</Text>
                        <Input name="agencyDetails.certificationExpiry" type="date" defaultValue={profileData.agencyDetails.certificationExpiry} isReadOnly={!isEditable} />
                      </Box>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Issuing Authority</Text>
                        <Input name="agencyDetails.issuingAuthority" defaultValue={profileData.agencyDetails.issuingAuthority} isReadOnly={!isEditable} />
                      </Box>
                    </Stack>
                  </CardBody>
                </Card>

                <Card mb={6} boxShadow="2xl" borderRadius="md">
                  <CardHeader>
                    <Heading fontSize="md" textAlign="left">Specialties and Services</Heading>
                  </CardHeader>
                  <CardBody>
                    <Stack spacing={3}>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Specialties</Text>
                        <Textarea name="specialties" placeholder="Specialties" defaultValue={profileData.specialties} isReadOnly={!isEditable} />
                      </Box>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Services</Text>
                        <Textarea name="services" placeholder="Services" defaultValue={profileData.services} isReadOnly={!isEditable} />
                      </Box>
                    </Stack>
                  </CardBody>
                </Card>

                <Card mb={6} boxShadow="2xl" borderRadius="md">
                  <CardHeader>
                    <Heading fontSize="md" textAlign="left">Organizational Details</Heading>
                  </CardHeader>
                  <CardBody>
                    <Stack spacing={3}>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Organization Type</Text>
                        <Input name="organization_type" placeholder="Organization Type" defaultValue={profileData.organization_type} isReadOnly={!isEditable} />
                      </Box>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Organizational Specialization</Text>
                        <Input name="organizational_specialization" defaultValue={profileData.organizational_specialization} isReadOnly={!isEditable} />
                      </Box>
                      <Box>
                        <Text fontWeight="bold" textAlign="left">Accreditations</Text>
                        <Textarea name="accreditations" placeholder="Accreditations" defaultValue={profileData.accreditations} isReadOnly={!isEditable} />
                      </Box>
                    </Stack>
                  </CardBody>
                </Card>
              </>
            )}
          </>
        )}
      </form>
    </Box>
  );
}

export default MyProfile;